module.exports = __webpack_public_path__ + "static/media/profile.bf602224.svg";